<template>
    <div style="height: 100%;">
      <van-nav-bar title="美发数据" left-text="返回" left-arrow @click-left="historyBack"/>
        <div style="width: 100%;padding-bottom: 10px;margin-top: 5px;text-align: center">
            <el-radio-group v-model="hairPosition" @change="hairClick" size="mini">
              <el-radio-button label="2">本月</el-radio-button>
              <el-radio-button label="3">上月</el-radio-button>
            </el-radio-group>
          </div>
          <el-table :data="hairDatas" border :show-header="false" style="width: 100%" height="calc(100% - 2.5rem)">
            <el-table-column prop="date">
            <template slot-scope="scope">
              
                <el-row>
                  <el-col :span="8">
                      {{scope.row.storename}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="">
                      美发业绩:{{parseInt(scope.row.haircashperf)}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    
                      业绩占比:{{Math.round(scope.row.hairlv *100)}}%
                  
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    
                    头疗数量:{{scope.row.tlnumber}}
                    
                  </el-col>
                  <el-col :span="8">
                    
                    美发客数:{{scope.row.haircount}}
                    
                  </el-col>
                  <el-col :span="8">
                    
                      散客数量:{{scope.row.skcount}}
                    
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    
                    大项客数:{{scope.row.dxcount}}({{Math.round(scope.row.dxlv *100)}}%)
                    
                  </el-col>
                  <el-col :span="8">
                    护理客数:{{scope.row.hlcount}}({{Math.round(scope.row.hllv *100)}}%)
                  </el-col>
                  <el-col :span="8">
                    
                    头皮客数:{{scope.row.tpcount}}({{Math.round(scope.row.tplv *100)}}%)
                    
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    新增会员:{{scope.row.newcount}}({{Math.round(scope.row.cjlv *100)}}%)
                  </el-col>
                  <el-col :span="8">
                    
                      团购人数:{{scope.row.dptgcount}}
                    
                  </el-col>
                  <el-col :span="8">
                    
                    成交人数:{{scope.row.dptgcjcount}}({{Math.round(scope.row.dptglv *100)}}%)
                    
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    
                    团购金额:{{scope.row.dptgamount}}
                    
                  </el-col>
                  <el-col :span="8">
                    
                      团购大项:{{scope.row.dxnumber}}
                    
                  </el-col>
                  <el-col :span="8">
                    
                    团购小项:{{scope.row.xxnumber}}
                    
                  </el-col>
                </el-row>
              
            </template>
            </el-table-column>
          </el-table>
    </div>
</template>

<script>
export default {
    data(){
        return {
            storeid:localStorage.getItem("storeid"),
            hairPosition:"2",
            hairDatas:[],
            hlfromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
            hltodate:this.$moment().endOf('month').format('YYYY-MM-DD'),
        }
    },
    created: function () {
        this.getHairDeptInfo();
    },
    methods:{
        hairClick(e){
            if(e==2){
                this.hlfromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                this.hltodate=this.$moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(e==3){
                let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.hlfromdate=days+"-01";
                this.hltodate=days+"-"+this.$moment(this.hlfromdate, "YYYY-MM-DD").daysInMonth();
            }
            this.getHairDeptInfo();
        },
        getHairDeptInfo(){
            this.$post("cashreport/getHairDeptInfo",{storeid:this.storeid,fromdate:this.hlfromdate,todate:this.hltodate}).then(res=>{
                if(res.sucess){
                    this.hairDatas=res.object;
                }
                else{
                    this.$message.error(res.message);
                }
            });
        },
    },
}
</script>
<style style lang="scss" rel="stylesheet/scss">
    .el-table .el-form-item__label{
        padding: 0px;
    }

    .el-table .el-form-item{
        margin-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/page/manager/hairdata.vue